module.exports = __webpack_public_path__ + "img/loading.ae2e7bfe.gif";